import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: "history",
    routes: [
        {
            path: "/",
            name: "home",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/Home.vue")
        },
        {
            path: "/quiz",
            name: "quiz",
            component: () =>
                import(/* webpackChunkName: "quiz" */ "./views/Quiz.vue")
        },
        {
            path: "/playlist/:user/:characterPlaylist/:userPlaylistId?",
            name: "playlist",
            props: true,
            component: () =>
                import(/* webpackChunkName: "playlist" */ "./views/Playlist.vue")
        },
        {
            path: "/",
            redirect: "home"
        }
    ]
});